import React, { Component, Fragment } from 'react'
import firebase from '../../modules/Firebase'
import AppTableRows from '../../components/AppTableRows'
import LatestReleasePlatform from '../../components/LatestReleasePlatform'
import Modal from '../../components/Modal'
import AddReleaseForm from '../../components/AddReleaseForm'
import Confirmation from '../../components/Confirmation'
import {
  Table,
  Grid,
  Row,
  Col,
  Button,
} from 'react-bootstrap'

class Home extends Component {
  state = {
    webApps: {},
    packagedApps: {},
    showAddReleaseModal: false,
    showDeleteConfirmation: false,
    confirmationCallback: null,
  }

  componentDidMount() {
    const releasesRef = firebase.database().ref('releases')
    releasesRef.on('value', (snapshot) => {
      this.setState(snapshot.val())
    })
  }

  deletePackagedRelease = (key, platform) => {
    const dataRef = firebase.database().ref(`releases/packagedApps/${platform}/${key}`)
    const deleteFunc = () => {
      dataRef.remove()
      this.toggleConfirmation()
    }
    this.setState({
      showDeleteConfirmation: true,
      confirmationCallback: deleteFunc,
    })
  }

  addRelease = () => {
    this.setState({
      showAddReleaseModal: true,
    })
  }

  toggleModal = () => {
    this.setState({
      showAddReleaseModal: false,
    })
  }

  toggleConfirmation = () => {
    this.setState({
      showDeleteConfirmation: false,
      confirmationCallback: null,
    })
  }

  render() {
    const {
      webApps,
      packagedApps,
      showAddReleaseModal,
      showDeleteConfirmation,
      confirmationCallback,
    } = this.state

    const platforms = Object.keys(webApps)
    const csaiPlatforms = platforms.filter((platform) => {
      return platform === 'freeview' || platform === 'freesat-g3' || platform === 'youview';
    })
    const ssaiPlatforms = platforms.filter((platform) => {
      return platform !== 'freeview' && platform !== 'samsung' && platform !== 'freesat' && platform !== 'freesat-g3' &&  platform !== 'youview' && platform !== 'freeview-blr' && platform !== 'firetv' && platform !== 'virginmedia-compass';
    })
    const legacyPlatforms = platforms.filter((platform) => {
      return platform === 'firetv' || platform === 'samsung' || platform === 'virginmedia-compass' || platform === 'freesat' || platform === 'freeview-blr';
    })
    const packagedAppPlatforms = Object.keys(packagedApps)

    return (
      <Fragment>
        <Grid>
          <Row className="show-grid">
            <Col md={12}>
              <h3>CSAI App Releases</h3>
              <br />
              <Table bordered hover>
              {
                csaiPlatforms.map((platform, i) => (
                  <Fragment key={platform + i}>
                    <thead>
                        <tr>
                          <th colSpan="12">
                            <img src={`images/${platform.toLowerCase()}.png`} alt={`${platform}`} />
                          </th>
                        </tr>
                    </thead>
                    <tbody>
                      <AppTableRows releases={webApps[platform]} />
                    </tbody>
                  </Fragment>
                ))
              }
              </Table>
              <br />
              <br />
              <h3>SSAI App Releases</h3>
              <br />
              <Table bordered hover>
              {
                ssaiPlatforms.map((platform, i) => (
                  <Fragment key={platform + i}>
                    <thead>
                        <tr>
                          <th colSpan="12">
                            <img src={`images/${platform.toLowerCase()}.png`} alt={`${platform}`} />
                          </th>
                        </tr>
                    </thead>
                    <tbody>
                      <AppTableRows releases={webApps[platform]} />
                    </tbody>
                  </Fragment>
                ))
              }
              </Table><br />
              <br />
              <h3>Legacy App Releases</h3>
              <br />
              <Table bordered hover>
              {
                legacyPlatforms.map((platform, i) => (
                  <Fragment key={platform + i}>
                    <thead>
                        <tr>
                          <th colSpan="12">
                            <img src={`images/${platform.toLowerCase()}.png`} alt={`${platform}`} />
                          </th>
                        </tr>
                    </thead>
                    <tbody>
                      <AppTableRows releases={webApps[platform]} />
                    </tbody>
                  </Fragment>
                ))
              }
              </Table>
            </Col>
            {/*<Col md={12}>*/}
            {/*  <br />*/}
            {/*  <h3>Packaged App Releases</h3>*/}
            {/*  <br />*/}
            {/*  <p>*/}
            {/*    <Button bsStyle="primary" onClick={this.addRelease}>Add Release</Button>*/}
            {/*  </p>*/}
            {/*  <Table bordered hover>*/}
            {/*  {*/}
            {/*    packagedAppPlatforms.map((platformName, i) => (*/}
            {/*      <Fragment key={platformName + i}>*/}
            {/*        <thead>*/}
            {/*            <tr>*/}
            {/*              <th colSpan="12">*/}
            {/*                <img src={`images/${platformName.toLowerCase()}.png`} alt={`${platformName}`} />*/}
            {/*              </th>*/}
            {/*            </tr>*/}
            {/*        </thead>*/}
            {/*        <tbody>*/}
            {/*          <AppTableRows releases={packagedApps[platformName]} canDelete onDelete={(key) => this.deletePackagedRelease(key, platformName)} />*/}
            {/*        </tbody>*/}
            {/*      </Fragment>*/}
            {/*    ))*/}
            {/*  }*/}
            {/*  </Table>*/}
            {/*</Col>*/}
          </Row>
        </Grid>
        {/*<Modal title="Add Release" show={showAddReleaseModal} onClose={this.toggleModal}>*/}
        {/*  <AddReleaseForm onSuccess={this.toggleModal} />*/}
        {/*</Modal>*/}
        {/*<Modal title="Delete Release" show={showDeleteConfirmation} onClose={this.toggleConfirmation}>*/}
        {/*  <Confirmation*/}
        {/*    message="Are you sure you wish to continue?"*/}
        {/*    onConfirm={confirmationCallback}*/}
        {/*  />*/}
        {/*</Modal>*/}
      </Fragment>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/routes/home/index.js